import {
  CREATE_LIST_SIGN_METHOD,
  CREATE_LIST_SIGN_METHOD_FAIL,
  CREATE_LIST_SIGN_METHOD_SUCCESS,
  CREATE_SIGN_METHOD,
  CREATE_SIGN_METHOD_FAIL,
  CREATE_SIGN_METHOD_SUCCESS,
  DELETE_SIGN_METHOD,
  DELETE_SIGN_METHOD_FAIL,
  DELETE_SIGN_METHOD_SUCCESS,
  EDIT_SIGN_METHOD,
  EDIT_SIGN_METHOD_FAIL,
  EDIT_SIGN_METHOD_SUCCESS,
  GET_ALL_SIGN_METHOD,
  GET_ALL_SIGN_METHOD_FAIL,
  GET_ALL_SIGN_METHOD_SUCCESS,
  GET_DETAIL_SIGN_METHOD,
  GET_DETAIL_SIGN_METHOD_FAIL,
  GET_DETAIL_SIGN_METHOD_SUCCESS,
  GET_LIST_SIGN_METHOD,
  GET_LIST_SIGN_METHOD_FAIL,
  GET_LIST_SIGN_METHOD_SUCCESS,
  GET_LIST_VAT,
  GET_LIST_VAT_FAIL,
  GET_LIST_VAT_SUCCESS,
  RESET_CREATE_LIST_SIGN_METHOD,
  RESET_CREATE_SIGN_METHOD,
  RESET_DELETE_SIGN_METHOD,
  RESET_EDIT_SIGN_METHOD,
  RESET_GET_ALL_SIGN_METHOD,
  RESET_GET_LIST_VAT,
  RESET_LIST_SIGN_METHOD,
  SET_COLUMN_VISIBLE_SIGN_METHOD,
} from "./actionTypes";

// SignMethod
export const getListSignMethod = params => ({
  type: GET_LIST_SIGN_METHOD,
  params,
});

export const getListSignMethodSuccess = (listData, totalCount) => ({
  type: GET_LIST_SIGN_METHOD_SUCCESS,
  listData,
  totalCount,
});

export const getListSignMethodFail = error => ({
  type: GET_LIST_SIGN_METHOD_FAIL,
  error,
});

export const resetListSignMethod = error => ({
  type: RESET_LIST_SIGN_METHOD,
});

// Chi tiết SignMethod
export const getDetailSignMethod = id => ({
  type: GET_DETAIL_SIGN_METHOD,
  id,
});

export const getDetailSignMethodSuccess = data => ({
  type: GET_DETAIL_SIGN_METHOD_SUCCESS,
  data,
});

export const getDetailSignMethodFail = error => ({
  type: GET_DETAIL_SIGN_METHOD_FAIL,
  error,
});

// Tạo SignMethod
export const createSignMethod = data => ({
  type: CREATE_SIGN_METHOD,
  data,
});

export const createSignMethodSuccess = data => ({
  type: CREATE_SIGN_METHOD_SUCCESS,
  data,
});

export const createSignMethodFail = error => ({
  type: CREATE_SIGN_METHOD_FAIL,
  error,
});
export const resetCreateSignMethod = error => ({
  type: RESET_CREATE_SIGN_METHOD,
});

// Tạo list SignMethod
export const createListSignMethod = data => ({
  type: CREATE_LIST_SIGN_METHOD,
  data,
});

export const createListSignMethodSuccess = data => ({
  type: CREATE_LIST_SIGN_METHOD_SUCCESS,
  data,
});

export const createListSignMethodFail = error => ({
  type: CREATE_LIST_SIGN_METHOD_FAIL,
  error,
});
export const resetCreateListSignMethod = error => ({
  type: RESET_CREATE_LIST_SIGN_METHOD,
});

// EDIT SignMethod
export const editSignMethod = (data, id) => ({
  type: EDIT_SIGN_METHOD,
  data,
  id,
});

export const editSignMethodSuccess = data => ({
  type: EDIT_SIGN_METHOD_SUCCESS,
  data,
});

export const editSignMethodFail = error => ({
  type: EDIT_SIGN_METHOD_FAIL,
  error,
});
export const resetEditSignMethod = error => ({
  type: RESET_EDIT_SIGN_METHOD,
});

// Delete SignMethod
export const deleteSignMethod = id => ({
  type: DELETE_SIGN_METHOD,
  id,
});

export const deleteSignMethodSuccess = data => ({
  type: DELETE_SIGN_METHOD_SUCCESS,
  data,
});

export const deleteSignMethodFail = error => ({
  type: DELETE_SIGN_METHOD_FAIL,
  error,
});

export const resetDeleteSignMethod = error => ({
  type: RESET_DELETE_SIGN_METHOD,
});

// Get list Vat
export const getListVat = () => ({
  type: GET_LIST_VAT,
});

export const getListVatSuccess = data => ({
  type: GET_LIST_VAT_SUCCESS,
  data,
});

export const getListVatFail = error => ({
  type: GET_LIST_VAT_FAIL,
  error,
});

export const resetGetListVat = error => ({
  type: RESET_GET_LIST_VAT,
});

// getAllSignMethod
export const getAllSignMethod = () => ({
  type: GET_ALL_SIGN_METHOD,
});

export const getAllSignMethodSuccess = data => ({
  type: GET_ALL_SIGN_METHOD_SUCCESS,
  data,
});

export const getAllSignMethodFail = error => ({
  type: GET_ALL_SIGN_METHOD_FAIL,
  error,
});

export const resetGetAllSignMethod = error => ({
  type: RESET_GET_ALL_SIGN_METHOD,
});

// show/hide column
export const setColumnVisibleSignMethod = (field, value) => ({
  type: SET_COLUMN_VISIBLE_SIGN_METHOD,
  field,
  value,
});
